import { gql } from 'apollo-boost';
import { useQuery } from 'react-apollo';
import { uniqBy } from 'lodash';

const query = gql`
  query {
    indicatorGroups {
      dbId
      name
    }
  }
`;

export const useIndicatorBenchmarks = () => {
  const { data: rawData, refetch, loading } = useQuery(query, { fetchPolicy: 'cache-first' });
  const data = uniqBy((rawData?.indicatorGroups || []), 'name').map(row => ({ ...row, id: row.dbId }));
  return { data, refetch, loading };
};
